// extracted by mini-css-extract-plugin
export var inner = "Loading-module--inner--JiFoo";
export var pulse = "Loading-module--pulse--GStTp";
export var root = "Loading-module--root--ZJd1e";
export var title = "Loading-module--title---6Iw0";